/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ylbqjezyznhjvaooou2zbxkzwa.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ctfgvktltfcyjijimgk57452wa",
    "aws_cognito_identity_pool_id": "us-east-1:c1a7c67b-d3fe-45c5-86ea-67b756bbbf08",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_IEt7SjX90",
    "aws_user_pools_web_client_id": "56or1pope3o0gagp76sb41bc08",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "medifind-storage35601-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
